/* tslint:disable */
/* eslint-disable */
/**
 * The Selling Partner API for FBA inbound operations.
 * The Selling Partner API for Fulfillment By Amazon (FBA) Inbound. The FBA Inbound API enables building inbound workflows to create, manage, and send shipments into Amazon\'s fulfillment network. The API has interoperability with the Send-to-Amazon user interface.
 *
 * The version of the OpenAPI document: 2024-03-20
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Preparation instructions for shipping an item to Amazon\'s fulfillment network. For more information about preparing items for shipment to Amazon\'s fulfillment network, refer to [Seller Central Help for your marketplace](https://developer-docs.amazon.com/sp-api/docs/seller-central-urls).
 */

export const PrepType = {
    ItemBlackShrinkwrap: 'ITEM_BLACK_SHRINKWRAP',
    ItemBlankstk: 'ITEM_BLANKSTK',
    ItemBoxing: 'ITEM_BOXING',
    ItemBubblewrap: 'ITEM_BUBBLEWRAP',
    ItemCapSealing: 'ITEM_CAP_SEALING',
    ItemDebundle: 'ITEM_DEBUNDLE',
    ItemHangGarment: 'ITEM_HANG_GARMENT',
    ItemLabeling: 'ITEM_LABELING',
    ItemNoPrep: 'ITEM_NO_PREP',
    ItemPolybagging: 'ITEM_POLYBAGGING',
    ItemRmovhang: 'ITEM_RMOVHANG',
    ItemSetcreat: 'ITEM_SETCREAT',
    ItemSetstk: 'ITEM_SETSTK',
    ItemSioc: 'ITEM_SIOC',
    ItemSuffostk: 'ITEM_SUFFOSTK',
    ItemTaping: 'ITEM_TAPING',
} as const;

export type PrepType = typeof PrepType[keyof typeof PrepType];



